import { Injectable } from "@angular/core";
import {
  FiltersTableJSON,
  PreviousValuesOfFilters,
} from "../models/filter-table-state.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class FiltersTableStateService {
  private filtersTableJSON: FiltersTableJSON;
  private filtersTableJSONHistory: FiltersTableJSON;

  private previousValuesOfFilters: PreviousValuesOfFilters;
  private previousValuesOfFiltersOutTable: PreviousValuesOfFilters;

  private personalSize: number = 10;

  constructor() {}

  setFiltersTable(filtersTableJSON: FiltersTableJSON) {
    this.filtersTableJSON = filtersTableJSON;
  }

  setFiltersTableHistory(filtersTableJSON: FiltersTableJSON) {
    this.filtersTableJSONHistory = filtersTableJSON;
  }

  initFiltersTable(
    order: string,
    screenId: string,
    setGlobalFilters: boolean = true
  ) {
    let filtersTableJSON: FiltersTableJSON = {
      asc: true,
      order: order,
      page: 0,
      size: this.personalSize,
      screenId: screenId,
    };
    filtersTableJSON = this.isTheSameTable(filtersTableJSON);
    if (setGlobalFilters) this.filtersTableJSON = filtersTableJSON;
    return filtersTableJSON;
  }

  initFiltersTableDesc(
    order: string,
    screenId: string,
    setGlobalFilters: boolean = true
  ) {
    let filtersTableJSON: FiltersTableJSON = {
      asc: false,
      order: order,
      page: 0,
      size: this.personalSize,
      screenId: screenId,
    };
    filtersTableJSON = this.isTheSameTable(filtersTableJSON);
    if (setGlobalFilters) this.filtersTableJSON = filtersTableJSON;
    return filtersTableJSON;
  }

  initFiltersTableHistory(order: string, screenId: string) {
    let filtersTableJSON: FiltersTableJSON = {
      asc: false,
      order: order,
      page: 0,
      size: this.personalSize,
      screenId: screenId,
    };
    filtersTableJSON = this.isTheSameTableHistory(filtersTableJSON);
    this.filtersTableJSONHistory = filtersTableJSON;
    return this.filtersTableJSONHistory;
  }

  getString(filtersTableJSON: FiltersTableJSON): string {
    return (
      "asc=" +
      filtersTableJSON["asc"] +
      "&order=" +
      filtersTableJSON["order"] +
      "&page=" +
      filtersTableJSON["page"] +
      "&size=" +
      filtersTableJSON["size"]
    );
  }

  initFiltersTableMasterTable(
    order: string,
    screenId: string,
    setGlobalFilters: boolean = true
  ): FiltersTableJSON {
    let filtersTableJSON: FiltersTableJSON = {
      asc: true,
      order: order,
      page: 1,
      size: this.personalSize,
      screenId: screenId,
    };
    filtersTableJSON = this.isTheSameTable(filtersTableJSON);
    if (setGlobalFilters) this.filtersTableJSON = filtersTableJSON;
    return filtersTableJSON;
  }

  private isTheSameTable(filtersTableJSON: FiltersTableJSON): FiltersTableJSON {
    if (
      this.filtersTableJSON &&
      this.filtersTableJSON.screenId === filtersTableJSON.screenId &&
      filtersTableJSON.screenId !== ScreenConstants.relatedRequests
    ) {
      console.log("Estamos en la misma tabla");
      filtersTableJSON.asc = this.filtersTableJSON.asc;
      filtersTableJSON.order = this.filtersTableJSON.order;
      filtersTableJSON.page = this.filtersTableJSON.page;
      filtersTableJSON.size = this.filtersTableJSON.size;
    }

    return filtersTableJSON;
  }

  private isTheSameTableHistory(
    filtersTableJSON: FiltersTableJSON
  ): FiltersTableJSON {
    if (
      this.filtersTableJSONHistory &&
      this.filtersTableJSONHistory.screenId === filtersTableJSON.screenId &&
      filtersTableJSON.screenId !== ScreenConstants.relatedRequests
    ) {
      console.log("Estamos en la misma tabla");
      filtersTableJSON.asc = this.filtersTableJSONHistory.asc;
      filtersTableJSON.order = this.filtersTableJSONHistory.order;
      filtersTableJSON.page = this.filtersTableJSONHistory.page;
      filtersTableJSON.size = this.filtersTableJSONHistory.size;
    }

    return filtersTableJSON;
  }

  getFiltersTableState(): FiltersTableJSON {
    return this.filtersTableJSON;
  }
  getFiltersTableStateHistory(): FiltersTableJSON {
    return this.filtersTableJSONHistory;
  }

  setAscState(asc) {
    this.filtersTableJSON.asc = asc;
  }
  setOrderState(order) {
    this.filtersTableJSON.order = order;
  }
  setPageState(page) {
    this.filtersTableJSON.page = page;
  }
  setPageStateHistory(page) {
    this.filtersTableJSONHistory.page = page;
  }
  setSizeState(size) {
    this.filtersTableJSON.size = size;
  }
  getPersonalSize(): number {
    return this.personalSize;
  }

  setPersonalSize(size: number): void {
    this.personalSize = size;
  }

  public setPreviousValuesOfFilters(
    previousValuesOfFilters: PreviousValuesOfFilters
  ): void {
    this.previousValuesOfFilters = {
      filterList: previousValuesOfFilters.filterList,
      filtersValuesSearch: previousValuesOfFilters.filtersValuesSearch,
      filtersSelectorSearch: previousValuesOfFilters.filtersSelectorSearch,
    };
  }
  public getPreviousValuesOfFilters(): String[] {
    return this.previousValuesOfFilters.filtersValuesSearch;
  }

  public getPreviousValuesOfFiltersSelector(): String[] {
    return this.previousValuesOfFilters.filtersSelectorSearch;
  }

  public setPreviousValuesOfFiltersOutTable(
    previousValuesOfFilters: PreviousValuesOfFilters
  ): void {
    this.previousValuesOfFiltersOutTable = {
      filterList: previousValuesOfFilters.filterList,
      filtersValuesSearch: previousValuesOfFilters.filtersValuesSearch,
      filtersSelectorSearch: previousValuesOfFilters.filtersSelectorSearch,
    };
  }
  public getPreviousValuesOfFiltersOutTable(): String[] {
    return this.previousValuesOfFiltersOutTable.filtersValuesSearch;
  }

  public getPreviousValuesOutTableOfFiltersSelector(): String[] {
    return this.previousValuesOfFiltersOutTable.filtersSelectorSearch;
  }

  public checkIfIsSameScreen(
    filters: any[],
    type: "normal" | "outTable"
  ): boolean {
    let filterListSaved =
      type === "normal"
        ? this.previousValuesOfFilters?.filterList
        : this.previousValuesOfFiltersOutTable?.filterList;
    if (
      filters &&
      filters.length > 0 &&
      filterListSaved &&
      filterListSaved.length > 0
    ) {
      return filterListSaved.every((obj1, index) => {
        const obj2 = filters[index];

        if (
          typeof obj1 === "object" &&
          obj1 !== null &&
          typeof obj2 === "object" &&
          obj2 !== null
        ) {
          return this.areObjectsEqual(obj1, obj2);
        } else {
          return obj1 === obj2;
        }
      });
    } else {
      return false;
    }
  }

  private areObjectsEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every((key) => {
      const val1 = obj1[key];
      const val2 = obj2[key];

      if (
        typeof val1 === "object" &&
        val1 !== null &&
        typeof val2 === "object" &&
        val2 !== null
      ) {
        return this.areObjectsEqual(val1, val2);
      } else {
        return val1 === val2;
      }
    });
  }

  public composeFiltersOutTable(filters: any): string {
    if (
      this.previousValuesOfFiltersOutTable &&
      this.checkIfIsSameScreen(filters, "outTable")
    ) {
      return this.composeParamsFilters(this.previousValuesOfFiltersOutTable);
    } else {
      return "";
    }
  }

  public composeFiltersInTable(filters: any): string {
    if (
      this.previousValuesOfFilters &&
      this.checkIfIsSameScreen(filters, "normal")
    ) {
      return this.composeParamsFilters(this.previousValuesOfFilters);
    } else {
      return "";
    }
  }

  public composeParamsFilters(
    filtersTableJSON: PreviousValuesOfFilters
  ): string {
    let value = "";
    filtersTableJSON.filterList.forEach((element, index) => {
      if (
        element["filterValue"] &&
        filtersTableJSON.filtersValuesSearch[index] !== undefined &&
        filtersTableJSON.filtersValuesSearch[index] !== null &&
        filtersTableJSON.filtersValuesSearch[index] !== ""
      ) {
        if (value.length == 0) {
          value =
            value +
            "_" +
            element["filterValue"] +
            "=" +
            encodeURI(filtersTableJSON.filtersValuesSearch[index]);
        } else {
          value =
            value +
            "&_" +
            element["filterValue"] +
            "=" +
            encodeURI(filtersTableJSON.filtersValuesSearch[index]);
        }
      }
      value = this.checkAndAddMultipleFilters(value, element);
    });
    value = this.composeSelectorSearch(filtersTableJSON, value);
    return value;
  }

  private checkAndAddMultipleFilters(value, element): string {
    if (
      element.multiple &&
      element.secondField &&
      element.secondField.value !== ""
    ) {
      if (value.length == 0) {
        value =
          value +
          "_" +
          element.secondField["filterValue"] +
          "=" +
          element.secondField.value;
      } else {
        value =
          value +
          "&_" +
          element.secondField["filterValue"] +
          "=" +
          element.secondField.value;
      }
    }
    return value;
  }

  private composeSelectorSearch(
    filtersTableJSON: PreviousValuesOfFilters,
    value: string
  ): string {
    let filterListSelectors = filtersTableJSON.filterList.filter(
      (element) => element["type"] == "select"
    );
    filtersTableJSON.filtersSelectorSearch.forEach((element, index) => {
      if (element.value && element.value[element.key] !== "") {
        let pos = filterListSelectors.findIndex(
          (e) => e["selectorConf"]["id"] == element.key
        );
        if (value == "") {
          value =
            value +
            "_" +
            filterListSelectors[pos]["filterValue"] +
            "=" +
            element.value[element.key];
        } else {
          value =
            value +
            "&_" +
            filterListSelectors[pos]["filterValue"] +
            "=" +
            element.value[element.key];
        }
      }
    });
    return value;
  }

  public composeParamsTwoArrays(): any {
    let result: any = {
      arrayKeys: [],
      arrayValues: [],
    };
    this.previousValuesOfFilters?.filterList.forEach((element, index) => {
      if (
        element["filterValue"] &&
        this.previousValuesOfFilters.filtersValuesSearch[index] !== undefined &&
        this.previousValuesOfFilters.filtersValuesSearch[index] !== null &&
        this.previousValuesOfFilters.filtersValuesSearch[index] !== ""
      ) {
        if (element.type === "date") {
          result.arrayKeys.push(element["filterValue"]);
          const fechaObjeto = moment(
            this.previousValuesOfFilters.filtersValuesSearch[index],
            "YYYY-MM-DD"
          );

          const fechaFormateada = fechaObjeto.format("DD/MM/yyyy");
          result.arrayValues.push(fechaFormateada);
        } else {
          result.arrayKeys.push(element["filterValue"]);
          result.arrayValues.push(
            this.previousValuesOfFilters.filtersValuesSearch[index]
          );
        }
      }
    });

    return result;
  }
}
